document.addEventListener("DOMContentLoaded", function () {
  const fadeupElements = document.querySelectorAll(".fadeup");

  const fadeInOnScroll = () => {
    fadeupElements.forEach((el) => {
      const rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight * 0.9) {
        el.classList.add("visible");
      }
    });
  };

  window.addEventListener("scroll", fadeInOnScroll);
  fadeInOnScroll(); // 初回チェック
});